module.exports = __webpack_public_path__ + "img/organization_ja.79b7c35a.jpg";